import React from "react";
import MembersGroupUserListItem from "../../components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const MembersGroupUserListPage = ()  => {

    useTitle(t`List Members Group User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <MembersGroupUserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default MembersGroupUserListPage;
